import script from "./AdminNotificationStack.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNotificationStack.vue?vue&type=script&setup=true&lang=js"

import "./AdminNotificationStack.vue?vue&type=style&index=0&id=9ce7c746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ce7c746"]])

export default __exports__